import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneEnterAuth.styl';

import './BXmakerAuthuserphoneEnterSmsCode';
import './BXmakerAuthuserphoneEnterUserCall';
import './BXmakerAuthuserphoneEnterBotCall';
import './BXmakerAuthuserphoneEnterBotSpeech';
import './BXmakerAuthuserphoneEnterAuthForm';
import './BXmakerAuthuserphoneEnterAuthByPasswordForm';


Vue.component('BXmakerAuthuserphoneEnterAuth', {
    name: 'BXmakerAuthuserphoneEnterAuth',
    template: `
            <div class="bxmaker-authuserphone-enter-auth"  >
                                
                 <BXmakerAuthuserphoneHeader class="bxmaker-authuserphone-enter-auth__title" >
                    {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_AUTH_TITLE}}
                 </BXmakerAuthuserphoneHeader>    
                                              
                    <BXmakerAuthuserphoneEnterAuthForm 
                        v-show="!$root.isShowConfirmation && !$root.isAuthByPassword" 
                    />  
                    
                    <BXmakerAuthuserphoneEnterAuthByPasswordForm 
                        v-show="!$root.isShowConfirmation && $root.isAuthByPassword" 
                    />   
                                        
                    <BXmakerAuthuserphoneEnterSmsCode  
                        v-show="$root.isNeedShowConfirmationSmsCode"                                    
                    /> 
                    
                    <BXmakerAuthuserphoneEnterUserCall  
                        v-show="$root.isNeedShowConfirmationUserCall"   
                    /> 
                    
                    <BXmakerAuthuserphoneEnterBotCall 
                         v-show="$root.isNeedShowConfirmationBotCall"                 
                    />  
                    
                    <BXmakerAuthuserphoneEnterBotSpeech 
                         v-show="$root.isNeedShowConfirmationBotSpeech"                 
                    />  
                    
                    <div class="bxmaker-authuserphone-enter-auth__change-confirm" v-if="$root.isNeedShowChangeConfirmation"  >
                         <BXmakerAuthuserphoneLink @onClick="$root.changeConfirmationType" >
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_CHANGE_CONFIRM_TYPE}}   
                         </BXmakerAuthuserphoneLink> 
                    </div>   
                    
                    
                    <div class="bxmaker-authuserphone-enter-auth__toregistration" v-if="!$root.isShowConfirm && $root.isEnabledRegister">
                         <BXmakerAuthuserphoneLink @onClick="$root.toRegistration" >
                                {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_TO_REGISTRATION}}   
                        </BXmakerAuthuserphoneLink> 
                    </div>
                                                
            </div>
        `,
});